// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p2-1";
export var messageSideRight = "_p2-2";
export var subscribeToBackInStockBubbleContainer = "_p2-0";